import React, { useEffect, useState, useRef, Children, createRef, createContext } from 'react';
import 'ag-psd/initialize-canvas';
import { readPsd } from 'ag-psd';
import CanvasLayer from './components/CanvasLayer';
import {IProps, IState} from './types';
import * as S from './styles';
import TreeNode from './components/TreeNode';
import Artboard from './components/Artboard';
const uuid = require('react-uuid');

const PreviewConstructor:React.FC<IProps> = (props, state: IState) => {

  const inputFile = useRef<HTMLInputElement>(null);
  const canvas = useRef<HTMLCanvasElement>(null);
  const [dimensions, setDimensions] = useState({width: 0, height: 0});
  const [previewDimensions, setPreviewDimensions] = useState({width: 0, height: 0});
  const [coors, setCoors] = useState({x: 0, y: 0});
  const [mouse, setMouse] = useState(false);
  const [globalClicked, setGlobalClicked] = useState("");
  const [psdObject, setPsdObject] = useState(state.psdObject);
  const [previewPsdObject, setPreviewPsdObject] = useState(state.previewPsdObject);
  const [previewOnly, setPreviewOnly] = useState(false);
  const [minMaxValues, setMinMaxValues] = useState({left: undefined, top: undefined, right: undefined, bottom: undefined} as any);

  const onButtonClick = () => {
    if (inputFile !== null && inputFile.current !== null) {
      inputFile.current.click();
    }
  };

  const handleInputChange = () => {
    setDocument();
  }

  useEffect(() => {
    const file = props.files?.length ? props.files[props.currentIndex ? props.currentIndex : 0] : undefined;
    if (file?.data) {
      if (file?.id !== psdObject?.name) loadPsd(file.data, file.id, false);
      setPreviewOnly(true);
    }
  }, [props.files, props.currentIndex])

  useEffect(() => {
    if (props.files?.length > 0 && props.filesProgress?.length > 0) {
      props.files.map((fileItem: any) => {
        const fileProgressIndex = props.filesProgress.findIndex((fileProgress: any) => (fileProgress.id === fileItem.id));
        if (
          fileItem.previews === undefined && 
          fileItem.data &&
          fileProgressIndex >= 0 && 
          fileItem?.id !== previewPsdObject?.id &&
          props.filesProgress[fileProgressIndex].progress > 0
        ) {
          setPreviewDimensions({width: fileItem.data.canvas.width, height: fileItem.data.canvas.height});
          setPreviewPsdObject(fileItem);
        }
      })
    }
  }, [props.filesProgress])

  useEffect(() => {
    if (props.files?.length > 0 && props.filesProgress?.length > 0) {
      const fileIndex = props.files.findIndex((file: any) => (file.id === previewPsdObject?.id));
      const fileProgressIndex = props.filesProgress.findIndex((fileProgress: any) => (fileProgress.id === previewPsdObject?.id));
      if (
        props.files[fileIndex]?.previews === undefined && 
        props.setFiles &&
        fileIndex >= 0 && 
        fileProgressIndex >= 0 &&
        previewPsdObject?.canvasLength === props.filesProgress[fileProgressIndex].progress
      ) {
        const previews = handleFinishExport(previewPsdObject.data, false);
        props.setFiles([
          ...props.files.slice(0, fileIndex),
          {...props.files[fileIndex], previews: previews},
          ...props.files.slice(fileIndex + 1)
        ]);
      }
    }
  }, [props.filesProgress])

  const loadPsd = (psd: any, fileName: string, loadCanvas: boolean) => {
    if (canvas.current) {
      canvas.current.width = psd.canvas.width;
      canvas.current.height = psd.canvas.height;
      setDimensions({width: psd.canvas.width, height: psd.canvas.height});
      var newMinMax: any = {left: undefined, top: undefined, right: undefined, bottom: undefined};
      const layers = getCanvasObjects(psd);
      if (psd.artboards && psd.children?.length > 0) {
        psd.children.map((child: any) => {
          const newLeft = child.artboard.rect.left;
          const newTop = child.artboard.rect.top;
          const newRight = child.artboard.rect.right;
          const newBottom = child.artboard.rect.bottom;
          if (!(newLeft === 0 && newTop === 0 && newRight === 0 && newBottom === 0)) {
            newMinMax = {
              left: newMinMax.left === undefined ? newLeft : newLeft < newMinMax.left ? newLeft : newMinMax.left, 
              top: newMinMax.top === undefined ? newTop : newTop < newMinMax.top ? newTop : newMinMax.top,
              right: newMinMax.right === undefined ? newRight : newRight > newMinMax.right ? newRight : newMinMax.right,
              bottom: newMinMax.bottom === undefined ? newBottom : newBottom > newMinMax.bottom ? newBottom : newMinMax.bottom
            }
            newMinMax.top = newMinMax.top - 8;
            newMinMax.bottom = newMinMax.bottom - 8;
          }
        })
      } else {
        layers.map((layer: any) => {
          if (!(layer.left === 0 && layer.top === 0 && layer.right === 0 && layer.bottom === 0)) {
            newMinMax = {
              left: newMinMax.left === undefined ? layer.left : layer.left < newMinMax.left ? layer.left : newMinMax.left, 
              top: newMinMax.top === undefined ? layer.top : layer.top < newMinMax.top ? layer.top : newMinMax.top,
              right: newMinMax.right === undefined ? layer.right : layer.right > newMinMax.right ? layer.right : newMinMax.right,
              bottom: newMinMax.bottom === undefined ? layer.bottom : layer.bottom > newMinMax.bottom ? layer.bottom : newMinMax.bottom
            }
          }
        })
      }
      setMinMaxValues(newMinMax);
      var newPsd: any = {};
      if (loadCanvas === true) newPsd = recursiveLayers(psd, undefined, undefined)
      else newPsd = psd;
      const name = fileName.toString();
      if (name.search('.psd') > 0) newPsd.name = name.substr(0, name.length - 4);
      else newPsd.name = name;
      setPsdObject(newPsd);
    }
  }

  const setDocument = () => {
    var myFiles:any = inputFile.current?.files;
    const myFile = myFiles[0];
    var reader = new FileReader();
    reader.readAsArrayBuffer(myFile);
    reader.onloadend = function (evt) {
      if (evt.target !== null && evt.target.readyState == FileReader.DONE) {
        const buffer:any = evt.target.result;
        let psd:any = readPsd(buffer);        
        //start remove big data not useful to us to have
        //a smaller json
        psd.imageResources.xmpMetadata = "";
        psd.engineData = "";
        psd.linkedFiles = [];
        //end remove
        const jsonString = JSON.stringify(psd);
        //download(myFile.name.replace(".psd",".json"),jsonString);
        loadPsd(psd, myFile.name, true);
      }
    }
  }

  function download(filename: string, text: string) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }
  
  const handleSave = () => {
    var dlAnchorElem = document.createElement('a');
    var canvasLayers: any = getCanvasObjects(psdObject);
    var newCanvasLayers: any = [];
    if (canvasLayers.length > 0) {
      canvasLayers.map((item: any) => {
        const canvasValue = item.canvas.toDataURL();
        newCanvasLayers = [...newCanvasLayers, {id: item.id, data: canvasValue}]
      })
    }
    var dataStr = "data:application/json;charset=utf-8," + encodeURIComponent(JSON.stringify(newCanvasLayers));
    dlAnchorElem.setAttribute("href", dataStr);
    dlAnchorElem.setAttribute("download", "scene.json");
    dlAnchorElem.click();
  }

  const handleFinishExport = (newPsdObject: any, download: boolean) => {
    var previewFiles: any = [];
    if (newPsdObject.artboards) {
      newPsdObject.children.map((child: any, index: number) => {
        var artboard = getCanvasObjects(child);
        const artboardBackground = {id: `background-${index}`, hidden: false};
        artboard = [artboardBackground, ...artboard];
        if (child?.artboard?.rect)
        var data: any = converToPng(newPsdObject, artboard, `${newPsdObject.name}-${child.name}`, {
          left: child.artboard.rect.left, 
          top: child.artboard.rect.top, 
          width: child.artboard.rect.right - child.artboard.rect.left, 
          height: child.artboard.rect.bottom - child.artboard.rect.top
        }, download);
        previewFiles = [...previewFiles, {name: child.name, url: data}];
      })
    } else {
      const layers = getCanvasObjects(newPsdObject);
      var data = converToPng(newPsdObject, layers, `${newPsdObject.name}`, {left: 0, top: 0, width: newPsdObject.width, height: newPsdObject.height}, download);
      previewFiles = [...previewFiles, {name: newPsdObject.name, url: data}];
    }
    return previewFiles;
  }

  const converToPng = (newPsdObject: any, items: any, filename: string, params: {left: number, top: number, width: number, height: number}, download: boolean) => {
    if (items && items.length > 0 && canvas.current) {
      var ctx = canvas.current.getContext('2d');
      if (ctx) {
        canvas.current.width = newPsdObject.width;
        canvas.current.height = newPsdObject.height;
        ctx.clearRect(0, 0, newPsdObject.width, newPsdObject.height);
        items.filter((item: any) => (item.hidden === false)).map((item: any) => {
          var canvasElement: any = document.getElementById(`${download === true ? 'canvas' : 'preview'}-${item.id}`);
          if (canvasElement !== null && ctx) {
            ctx.drawImage(canvasElement, 0, 0);
          }
        })
        var imageData = ctx.getImageData(params.left, params.top, params.width, params.height);
        ctx.clearRect(0, 0, newPsdObject.width, newPsdObject.height);
        canvas.current.width = params.width;
        canvas.current.height = params.height;
        ctx.putImageData(imageData, 0 ,0);
      }
      if (download === true) {
        var link = document.createElement('a');
        link.download = `${filename}.png`;
        link.href = canvas.current.toDataURL("image/png");
        link.click();
      }
      return canvas.current.toDataURL("image/png");
    }
  }

  const handleMouseMove = (e: any) => {
    setCoors({x: e.clientX, y: e.clientY});
  }

  const getCanvasObjects = (object: any) => {
    var children: any[] = [];
    if (object?.children?.length > 0) {
      object.children.map((child: any) => {
        if (child.children) {
          children = [...children, ...getCanvasObjects(child)];
        }
        if (child.canvas) {
          children = [...children, child];
        } 
      })
    }
    return children;
  }

  const handleHidden = (id: string) => {
    setPsdObject(handleRecursiveEdit(psdObject, id));
  }

  const handleRecursiveEdit = (object: any, id: string) => {
    var newPsd: any = {...object};
    if (object.children?.length > 0) {
      newPsd.children = [];
      object.children.map((child: any) => {
        newPsd.children = [...newPsd.children, {...handleRecursiveEdit(child, id), hidden: child.id === id ? !child.hidden : child.hidden}];
      })
    }
    newPsd.hidden = newPsd.id === id ? !newPsd.hidden : newPsd.hidden;
    return newPsd;
  }

  const recursiveLayers = (object: any, effects: any, mask: any) => {
    var newPsd: any = {...object};
    if (object.children?.length > 0) {
      newPsd.children = [];
      object.children.map((child: any) => {
        const canvasMask = child.mask?.canvas ? {...child.mask, canvas: child.mask.canvas.toDataURL()} : undefined
        newPsd.children = [...newPsd.children, {
          ...recursiveLayers(
            child, 
            child.effects ? child.effects : effects,
            child.mask ? canvasMask : mask
          ), 
          id: uuid(), 
          hidden: child.hidden ? child.hidden : false,
          canvas: child.canvas ? child.canvas.toDataURL() : undefined,
          effects: child.effects ? child.effects : effects,
          mask: child.mask ? canvasMask : mask
        }];
      })
    }
    newPsd.id = uuid();
    newPsd.hidden = newPsd.hidden ? newPsd.hidden : false;
    return newPsd;
  }

  const renderTree = (object: any) => {
    var children: any[] = [];
    if (object?.children?.length > 0) {
      object.children.map((child: any) => {
        children = [...children, 
          <TreeNode
            key={child.id}
            child={child}
            globalClicked={globalClicked}
            setGlobalClicked={setGlobalClicked}
            handleHidden={handleHidden}
          >
            {renderTree(child)}
          </TreeNode>
        ];
      })
    }
    return children;
  }

  const renderLayers = (object: any, fromPreview: boolean) => {
    var children: any[] = [];
    if (object?.children?.length > 0) {
      object.children.filter((item: any) => (item.hidden === false)).map((child: any) => {
        if (child.children) {
          children = [...children, ...renderLayers(child, fromPreview)];
        }
        if (child.canvas) {
          children = [...children, 
            <CanvasLayer
              key={child?.id}
              child={child}
              index={child?.id}
              coors={coors}
              mouse={mouse}
              dimensions={dimensions}
              globalClicked={globalClicked}
              setGlobalClicked={setGlobalClicked}
              previewOnly={previewOnly}
              fromPreview={fromPreview}
            />
          ];
        }
      })
    }
    return children;
  }

  const previewsConstructor = () => {
    return (
      <S.PreviewsConstructorContainer>
        { previewPsdObject?.data?.artboards ?
            previewPsdObject.data?.children?.filter((item: any) => (item.hidden === false)).map((child: any, index: number) => {
              return (
                <Artboard
                  key={index}
                  index={index}
                  coors={coors}
                  child={child}
                  dimensions={previewDimensions}
                  previewOnly={previewOnly}
                >
                  {renderLayers(child, true)}
                </Artboard>
              )
            })
          :
            renderLayers(previewPsdObject?.data, true)
        }
      </S.PreviewsConstructorContainer>
    )
  }

  return (
    <S.Root
      onMouseDown={() => setMouse(true)}
      onMouseUp={() => setMouse(false)} 
      onMouseMove={handleMouseMove}
      widthValue={previewOnly === true ? `${minMaxValues.right + 200}px` : '100vw'}
      heightValue={previewOnly === true ? `${minMaxValues.bottom + 200}px` : '100vh'}
      backgroundColor={previewOnly === true ? 'auto' : `#000000BB`}
    >
      {
        psdObject?.children?.length > 0 || previewOnly === true ? 
          <S.EditorContainer >
            <S.ZoomContainer
              widthValue={previewOnly === true ? `100%` : `calc(100% - 350px)`}
              onMouseDown={() => setGlobalClicked("")}
              backgroundColor={previewOnly === true ? 'auto' : `#00000090`}
              style={previewOnly === true ? {
                position: 'absolute',
                left: `-${minMaxValues.left ? minMaxValues.left/2 : 0}px`,
                top: `-${minMaxValues.top ? minMaxValues.top/2 : 0}px`,
                overflow: 'hidden',
              } : undefined}
            >
              {
                previewOnly === false &&
                <S.CanvasLayerBackground
                  style={{
                    width: `${dimensions.width}px`,
                    height: `${dimensions.height}px`
                  }}
                >
                  <S.BackgroundSpace />
                </S.CanvasLayerBackground>
              }
              {
                psdObject?.artboards ?
                psdObject.children?.filter((item: any) => (item.hidden === false)).map((child: any, index: number) => {
                  return (
                    <Artboard
                      key={index}
                      index={index}
                      coors={coors}
                      child={child}
                      dimensions={dimensions}
                      previewOnly={previewOnly}
                    >
                      {renderLayers(child, false)}
                    </Artboard>
                  )
                })
                :
                  renderLayers(psdObject, false)
              }
            </S.ZoomContainer>
            {
              previewOnly === false &&
              <>
                <S.LayerNamesContainer > 
                  {renderTree(psdObject)}
                </S.LayerNamesContainer>
                <S.ArtboardOptionContainer >
                  <S.ExportButton
                    onClick={handleSave}
                  >
                    SAVE
                  </S.ExportButton>
                  <S.ExportButton
                    onClick={() => handleFinishExport(psdObject, true)}
                  >
                    EXPORT
                  </S.ExportButton>
                </S.ArtboardOptionContainer>
              </>
            }
          </S.EditorContainer>
        :
          <button onClick={onButtonClick} style={{
            margin: '40px 0px 0px 40px'
          }} >
            OPEN PSD FILE
          </button>
      }
      <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={handleInputChange} multiple={true} accept=".psd" />
      <S.MainCanvas
        id={`main-canvas`} 
        ref={canvas}
      />
      {previewsConstructor()}
    </S.Root>
  );
}

export default PreviewConstructor;